import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-950 px-6 py-16 text-center text-white">
      <div className="w-full max-w-xl">
        <p className="mb-6 text-7xl font-black leading-none text-[#BCA4E3] sm:text-9xl">404</p>
        <h1 className="mb-4 text-3xl font-bold sm:text-4xl">Page not found</h1>
        <p className="mx-auto mb-8 max-w-md text-base leading-relaxed text-slate-400 sm:text-lg">
          The page you requested does not exist or may have moved.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-md bg-[#BCA4E3] px-5 py-3 font-semibold text-slate-900 transition-colors hover:bg-[#A88DD6]"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to home
        </Link>
      </div>
    </main>
  );
};

export default NotFoundPage;